import { Directive, ElementRef, Input } from '@angular/core';
import { SlIdContext } from './sl-id-context';

@Directive({ selector: '[sl-aria-describedby]' })
export class SlAriaDescribedbyDirective {
  constructor(private el: ElementRef, private ids: SlIdContext) {}

  @Input('sl-aria-describedby')
  set localIds(value: string) {
    if (!value || !value.trim()) {
      this.el.nativeElement.removeAttribute('aria-describedby');
      return;
    }

    var localIds = value.trim().split(/\s+/);
    var contextualIds: string[] = [];
    var i: number;

    for (i = 0; i < localIds.length; i++) {
      if (localIds[i]) {
        contextualIds.push(this.ids.id(localIds[i]));
      }
    }

    this.el.nativeElement.setAttribute('aria-describedby', contextualIds.join(' '));
    this.el.nativeElement.removeAttribute('sl-aria-describedby');
  }
}
